// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__suJyN","newExpiryDate":"styles_newExpiryDate__28DbL","footer":"styles_footer__1kNbB"};